module.exports = __webpack_public_path__ + "static/media/vc.8661a371.svg";